import React from 'react'
import MultiSelectChipsBelow from './MultiSelectChipsBelow'
import { Typography } from '@mui/material'

const accreditationCourse = [
    "UGC – University Grants Commission",
    "AICTE – All India Council for Technical Education",
    "NAAC – National Assessment and Accreditation Council",
    "NBA – National Board for Accreditation",
    "NIRF – National Institutional Ranking Framework",
    "WES – World Education Services (International)",
    "ABET – Accreditation Board for Engineering and Technology (International)",
    "AACSB – Association to Advance Collegiate Schools of Business (International)",
    "AMBA – Association of MBAs (International)",
    "EQUIS – EFMD Quality Improvement System (International)",
    "DEB – Distance Education Bureau (UGC-approved for online/distance education)",
]

const AccreditationforCourse = ({ label, value = [], onChange, readOnly = false }) => {
    return (
        <div>
            <Typography fontSize="14px" fontWeight="500" mb={1}>
                {label}
            </Typography>
            <MultiSelectChipsBelow
                placeholder="Select accreditation"
                options={accreditationCourse}
                value={value}
                onChange={onChange}
                readOnly={readOnly}
            />
        </div>
    )
}

export default AccreditationforCourse
